var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOnIc24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0003 4C9.1483 4 6.7573 5.395 4.9983 6.906C3.2333 8.423 2.0083 10.138 1.4643 10.97C1.26333 11.2759 1.15625 11.634 1.15625 12C1.15625 12.366 1.26333 12.7241 1.4643 13.03C2.0083 13.862 3.2333 15.577 4.9983 17.094C6.7583 18.605 9.1483 20 12.0003 20C14.8523 20 17.2433 18.605 19.0023 17.094C20.7673 15.577 21.9923 13.862 22.5363 13.03C22.9473 12.402 22.9473 11.599 22.5363 10.97C21.9923 10.138 20.7673 8.423 19.0023 6.906C17.2423 5.395 14.8523 4 12.0003 4ZM9.5003 12C9.5003 11.337 9.76369 10.7011 10.2325 10.2322C10.7014 9.76339 11.3373 9.5 12.0003 9.5C12.6633 9.5 13.2992 9.76339 13.7681 10.2322C14.2369 10.7011 14.5003 11.337 14.5003 12C14.5003 12.663 14.2369 13.2989 13.7681 13.7678C13.2992 14.2366 12.6633 14.5 12.0003 14.5C11.3373 14.5 10.7014 14.2366 10.2325 13.7678C9.76369 13.2989 9.5003 12.663 9.5003 12ZM12.0003 7.5C10.8068 7.5 9.66223 7.97411 8.81832 8.81802C7.9744 9.66193 7.5003 10.8065 7.5003 12C7.5003 13.1935 7.9744 14.3381 8.81832 15.182C9.66223 16.0259 10.8068 16.5 12.0003 16.5C13.1938 16.5 14.3384 16.0259 15.1823 15.182C16.0262 14.3381 16.5003 13.1935 16.5003 12C16.5003 10.8065 16.0262 9.66193 15.1823 8.81802C14.3384 7.97411 13.1938 7.5 12.0003 7.5Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOnIc24X24);
export default __webpack_public_path__ + "static/media/eye_on_ic_24x24.41a6241531d7e239a42feac78d5588a9.svg";
export { ForwardRef as ReactComponent };